module.exports = __webpack_public_path__ + "img/Feature.d22b321a.jpg";